import PackageIcon from "@/assets/icons/package-outline.svg?react";
import { Dimensions, PackageDetails, ShipmentDetails, Weight } from "@/types/fedex.type";
import { TrackingListElem } from "./trackingListElem";

type TrackingPackageDetailsProps = {
  packageDetails: PackageDetails;
  shipmentDetails: ShipmentDetails;
  locale: string;
};

export const TrackingPackageDetails = ({
  packageDetails,
  shipmentDetails,
  locale,
}: TrackingPackageDetailsProps) => {
  const displayDimensions = (dimensions: Dimensions[]) => {
    if (!dimensions || dimensions.length === 0) return "N/A";
    return dimensions[0].length + "x" + dimensions[0].width + "x" + dimensions[0].height + "cm";
  };

  const displayPackaging = (packagingType: string) => {
    if (packagingType === "YOUR_PACKAGING")
      return locale === "fr" ? "Votre conditionnement" : "Your packaging";
    return packagingType;
  };

  const displayWeight = (weight: Weight[]) => {
    if (!weight || weight.length === 0) return "N/A";
    return weight[0].value + " KG";
  };

  return (
    <div className="flex w-full flex-col gap-5 rounded-xl border border-gray-200 bg-white p-6 shadow-xs">
      <div className="flex w-full flex-row items-center gap-4">
        <PackageIcon width={24} height={24} />
        <span className="text-sm font-semibold text-black">
          {locale === "fr" ? "Détails du colis" : "Package details"}
        </span>
      </div>
      <div className="flex w-full flex-col gap-0">
        <TrackingListElem
          name={locale === "fr" ? "Poids" : "Weight"}
          value={displayWeight(packageDetails.weightAndDimensions?.weight || [])}
        />
        <TrackingListElem
          name={"Dimensions"}
          value={displayDimensions(packageDetails.weightAndDimensions?.dimensions || [])}
        />
        <TrackingListElem
          name={locale === "fr" ? "Nombre total" : "Number of packages"}
          value={packageDetails.count}
        />
        <TrackingListElem
          name={locale === "fr" ? "Poids total" : "Total weight"}
          value={displayWeight(shipmentDetails.weight)}
        />
        <TrackingListElem
          name={locale === "fr" ? "Conditionnement" : "Packaging"}
          value={displayPackaging(packageDetails.packagingDescription.type)}
          last
        />
      </div>
    </div>
  );
};
